import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Avatar, Drawer } from "antd";
import Notifications from "./components/Notifications";
import {
  GetNotificationApi,
  DeleteNotificationApi,
} from "../../../api/request/notification";
import Add from "../../../assets/Add";

const Header = ({
  collapsed,
  setCollapsed,
  isDrawerOpen,
  setIsDrawerOpen,
  title,
}) => {
  const navigate = useNavigate();
  const userDetails = useSelector((state) => state.user.userDetails);
  const [imageError, setImageError] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [isNotification, setIsNotification] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getInitials = (name) => {
    const nameParts = name?.trim()?.split(" ");
    if (nameParts) {
      const initials = nameParts[0][0] + nameParts[nameParts.length - 1][0];
      return initials.toUpperCase();
    }
  };

  const getNotifications = async () => {
    try {
      setIsLoading(true);
      const { data } = await GetNotificationApi();
      if (data?.status) setNotifications(data?.data);
    } catch (error) {}
    finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getNotifications();
  }, [userDetails?.id]);

  const openNotificationModal = () => {
    getNotifications();
    setIsNotification(true);
  };

  const getNotificationIds = async () => {
    return notifications
      ?.map((obj) => obj.id)
      ?.filter((id) => id !== undefined && id !== null)
      ?.join(",");
  };

  const clearNotifications = async () => {
    try {
      let params = { ids: await getNotificationIds() };
      const { data } = await DeleteNotificationApi(params);
      if (data.status) {
        setNotifications([]);
        toast.success(data.message);
        setIsNotification(false);
      }
    } catch (error) {}
  };

  return (
    <div className="border-b p-4 bg-White">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <svg
            onClick={() => setCollapsed(!collapsed)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 cursor-pointer hidden lg:block"
          >
            <path
              fillRule="evenodd"
              d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
              clipRule="evenodd"
            />
          </svg>
          <svg
            onClick={() => setIsDrawerOpen(!isDrawerOpen)}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6 cursor-pointer lg:hidden"
          >
            <path
              fillRule="evenodd"
              d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
              clipRule="evenodd"
            />
          </svg>
          <p className="page-title capitalize hidden md:block">{title}</p>
        </div>

        <div className="flex items-center sm:gap-3 gap-2 divide-x">
          <div className="flex items-center sm:gap-3 gap-2">
            <button
              className="btn-primary sm:!ps-3 sm:!pe-4 !ps-2 !pe-3 flex items-center justify-center sm:gap-2 gap-1"
              onClick={() => navigate("/document")}
            >
              <Add />
              Upload
            </button>

            <div
              className="border-Gray border h-8 w-8 sm:h-10 sm:w-10 rounded-full flex justify-center items-center"
              onClick={openNotificationModal}
            >
              {notifications?.length > 0 ? (
                <img
                  src="/assets/icons/notification-bell.svg"
                  className="h-5 sm:h-6 cursor-pointer"
                  alt="icon"
                />
              ) : (
                <img
                  src="/assets/icons/notification.svg"
                  className="h-5 sm:h-6 cursor-pointer"
                  alt="icon"
                />
              )}
            </div>
          </div>

          <div className="sm:ps-3 ps-2" onClick={() => navigate("/settings")}>
            <div className="flex items-center sm:gap-3 gap-2 cursor-pointer">
              <Avatar
                size="large"
                className="border-none bg-primary uppercase text-white font-medium"
                src={!imageError ? userDetails?.profile_image : null}
                onError={() => {
                  setImageError(true);
                  return false;
                }}
              >
                {getInitials(userDetails?.name)}
              </Avatar>
              <div className="md:block hidden">
                <p className="leading-5 capitalize sub-title text-ellipsis line-clamp-1">
                  {userDetails?.name}
                </p>
                <p className="text-ellipsis line-clamp-1">
                  {userDetails?.email}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Notification drawer */}
      <Drawer
        title={
          <div className="flex justify-between items-center">
            <p>Notifications</p>

            {notifications?.length ? (
              <p className="cursor-pointer" onClick={clearNotifications}>
                Clear all
              </p>
            ) : null}
          </div>
        }
        onClose={() => setIsNotification(false)}
        width={600}
        open={isNotification}
      >
        <Notifications
          notifications={notifications}
          getNotification={getNotifications}
          setIsNotification={setIsNotification}
          isLoading={isLoading}
        />
      </Drawer>
    </div>
  );
};

export default Header;
